import { studentMessages } from './en-US';

export const programId = '5dcf0b68e17b40251186eb9b';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
    messagesWithLocale: {
        'en-US': studentMessages,
    },
};
